import type EventMap from '@/interfaces/entities/EventMap.interface';
import type EventPoint from '@/interfaces/entities/EventPoint.interface';
import TransferStateService from 'transfer-state';

export default class EventMapService {
    private static instance: EventMapService;
    private transferStateService: TransferStateService = TransferStateService.getInstance();

    public static getInstance(): EventMapService {
        if (!EventMapService.instance) {
            EventMapService.instance = new EventMapService();
        }
        return EventMapService.instance;
    }

    public eventMap(): EventMap {
        return this.transferStateService.get<EventMap>('map');
    }

    public eventPoint(geoId: number): EventPoint {
        const eventPoint: EventPoint | undefined = this.eventPoints()
            .find((point: EventPoint): boolean => point.geoId === geoId.toString());
        if (!eventPoint) {
            throw new Error(`Point not found: ${geoId}`);
        }
        return eventPoint;
    }

    public eventPoints(): EventPoint[] {
        return this.transferStateService.get<EventPoint[]>('points', []);
    }
}
